
/*
 * This is copy-pasted from the HTML Spec for
 * email validation. See https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
 * for more info.
 */
const VALID_EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export function validateEmail(value) {
  return VALID_EMAIL_REGEX.test(value);
}

export function validatePhoneNumber(value) {
  const validChars = /[\d\s()+-]/;
  for (let i = 0; i < value.length; i++) {
    if (!validChars.test(value[i])) {
      return false;
    }
  }

  const numbers = value.replace(/\D/g, '');

  // Depending on presence of country code a phone number
  // can be between 10 and 14 chars.
  return numbers.length >= 10 && numbers.length <= 14;
}
